module.exports = __webpack_public_path__ + "static/img/on.a188da35.png";